import { useFormListValidator } from 'core';
import { CurrencyInput, NumberInput } from 'ui';
import { useForm } from 'ui/Form';

export type ChangeGoalFormType = {
  goal?: string;
};

type ChangeGoalFormProps = {
  goalType: 'currency' | 'units';
  initialValue?: string;
  units?: string;
};

const ChangeGoalForm = ({ goalType, initialValue, units }: ChangeGoalFormProps) => {
  const form = useForm<ChangeGoalFormType>({
    initialValues: {
      goal: initialValue,
    },
  });

  useFormListValidator({ form, id: 'peerGoal' });

  return goalType === 'currency' ? (
    <CurrencyInput
      label="Fundraising Goal"
      placeholder="Enter amount"
      allowNegative={false}
      {...form.getInputProps('goal')}
    />
  ) : (
    <NumberInput
      label={`Number of ${units}`}
      placeholder="Enter amount"
      allowNegative={false}
      {...form.getInputProps('goal')}
    />
  );
};

export { ChangeGoalForm };
